export type AskAIResponseStatus = "loading" | "streaming-cursor" | "none";

export const getAskAIResponseStatus = ({
  showLoadingUI,
  functionCallLabel,
  lastMessageIsStreaming,
  lastMessageContent,
  lastMessageIsFromAssistant,
  hasInFlightToolCall,
}: {
  showLoadingUI: boolean;
  functionCallLabel: string | null;
  lastMessageIsStreaming: boolean;
  lastMessageContent: string | null | undefined;
  lastMessageIsFromAssistant: boolean;
  hasInFlightToolCall: boolean;
}): AskAIResponseStatus => {
  const streamingAssistantContentHasStarted =
    lastMessageIsStreaming && !!lastMessageContent?.trim();

  if (streamingAssistantContentHasStarted) {
    return "streaming-cursor";
  }

  const hasLoadingSignal =
    showLoadingUI || !!functionCallLabel || lastMessageIsStreaming;

  if (
    hasLoadingSignal &&
    (!hasInFlightToolCall || lastMessageIsFromAssistant)
  ) {
    return "loading";
  }

  return "none";
};

// The stop button replaces the send button whenever a response is in flight
// (TF-1512): the same `loading` / `streaming-cursor` states that drive the
// working indicator.
export const shouldShowStopButton = (
  status: AskAIResponseStatus,
  hasInFlightToolCall = false,
): boolean =>
  status === "loading" || status === "streaming-cursor" || hasInFlightToolCall;
